import { render, staticRenderFns } from "./link.vue?vue&type=template&id=1b743cf3&scoped=true"
import script from "./link.vue?vue&type=script&lang=js"
export * from "./link.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b743cf3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\dianlala_project\\电啦啦\\cd-vue-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1b743cf3')) {
      api.createRecord('1b743cf3', component.options)
    } else {
      api.reload('1b743cf3', component.options)
    }
    module.hot.accept("./link.vue?vue&type=template&id=1b743cf3&scoped=true", function () {
      api.rerender('1b743cf3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/setting/link.vue"
export default component.exports